import { useQuery } from '@tanstack/react-query';

import { baseAPI } from './base-api';
import { KEYS } from './query-keys';

export type GhlLocationTag = {
  id: string;
  name: string;
};

type GhlLocationTagsResponse = {
  tags?: Array<{ id?: string; name?: string }>;
};

const normalizeGhlLocationTags = (
  data: GhlLocationTagsResponse | Array<{ id?: string; name?: string }> | null,
): Array<GhlLocationTag> => {
  const raw = Array.isArray(data)
    ? data
    : Array.isArray(data?.tags)
      ? data.tags
      : [];

  return raw
    .map((tag) => ({
      id: String(tag?.id ?? '').trim(),
      name: String(tag?.name ?? '').trim(),
    }))
    .filter((tag) => tag.id && tag.name)
    .sort((a, b) =>
      a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }),
    );
};

export const getGhlLocationTagsAPI = async (): Promise<
  Array<GhlLocationTag>
> => {
  const response = await baseAPI.get<
    GhlLocationTagsResponse | Array<{ id?: string; name?: string }>
  >('/ghl_auth/location/tags');
  return normalizeGhlLocationTags(response.data);
};

export const useGetGhlLocationTags = (enabled = true) =>
  useQuery({
    queryKey: [KEYS.GHL_LOCATION_TAGS],
    queryFn: getGhlLocationTagsAPI,
    enabled,
    staleTime: 5 * 60 * 1000,
  });
